// ─── Runtime configuration ─────────────────────────────────────────────────────
declare global {
  interface Window {
    __RUNTIME_CONFIG__?: Record<string, string | undefined>
  }
}

export function readRuntimeConfig(): Record<string, string> {
  const source = typeof window === 'undefined' ? undefined : window.__RUNTIME_CONFIG__
  if (!source) return {}

  return Object.fromEntries(
    Object.entries(source).filter(
      (entry): entry is [string, string] => typeof entry[1] === 'string' && entry[1].trim() !== '',
    ),
  )
}